export const FRAME_WIDTH = 960
export const FRAME_HEIGHT = 540

export const DEFAULT_COUNT_THRESHOLD = 1

export const DEFAULT_EVENT_SETTINGS = {
  notification: false,
  upload_video: true,
  upload_bbox_video: false
}

export const DEFAULT_EVENT_VIDEO_DURATION_TIME = 10 // in seconds
export const MIN_EVENT_VIDEO_DURATION_TIME = 5
export const MAX_EVENT_VIDEO_DURATION_TIME = 60

export const DEFAULT_PRE_EVENT_SECONDS = 3
export const MIN_PRE_EVENT_SECONDS = 0
export const MAX_PRE_EVENT_SECONDS = 10

export const MIN_CACHE_SECONDS = 10
export const MAX_CACHE_SECONDS = 60

export const DEFAULT_INFERENCE_INTERVAL = 0
export const INFERENCE_INTERVAL_OPTIONS = [0, 1, 2]

export const DEFAULT_MIN_DETECTION_FRAMES = 4
export const MIN_DETECTION_FRAMES = 1
export const MAX_DETECTION_FRAMES = 20
